import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { IStyledStatusPill } from 'types/ui/statusPill.interface'

export const StyledStatusPill = styled.span<IStyledStatusPill>`
  display: inline-flex;
  align-items: center;
  font-size: ${tokens.font.label};
  font-weight: 500;
  white-space: nowrap;
  padding: 0.25rem 0.5rem;
  border-radius: ${tokens.radius.chip};
  color: ${({ $status }) => tokens.status[$status].fg};
  background: ${({ $status }) => tokens.status[$status].bg};

  ${({ $dot, $status }) =>
    $dot &&
    `&::before {
      content: '';
      width: 0.4rem;
      height: 0.4rem;
      margin-right: 0.4rem;
      border-radius: 50%;
      flex: none;
      background: ${tokens.status[$status].fg};
      box-shadow: 0 0 6px ${tokens.status[$status].fg};
    }`}
`
